module.exports = __webpack_public_path__ + "b1303a153be1bfe3153c843dc1b251b7.svg";